import { Component, OnInit } from '@angular/core';
import { RouterPathService } from "../../../../core/common/variables/router-path.service";
import { TranslateService } from "../../../common/variables/translate-service";
import { ImagePathService } from "../../../../core/common/variables/image-path.service";
import { DrawRoof } from "../../../common/roof/draw_roof";
import { SC_Input } from "../../../common/input/SC_Input";
import { RoofType } from "../../../common/roof/RoofType";
import { MountingType } from "../../../common/mountsys/MountingType";
import { SC_Beam } from '../../../common/roof/SC_Beam';
import { AnchorType } from "../../../common/stocklist/AnchorType";
import { GlobalFunctionService } from "../../../common/services/global-function.service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'sen-app-roof-structure',
  templateUrl: './roof-structure.component.html',
  styleUrls: ['./roof-structure.component.scss']
})

export class RoofStructureComponent implements OnInit {
  prevPath: string;
  nextPath: string;
  trapezDirect: boolean = false;
  trapezCrisCross: boolean = false;
  rbPurlin: boolean;
  rbRafter: boolean;
  vbPurlinAdditional: boolean;
  hbRoofHook: boolean;
  nRoofRange: number;
  nRoofWidth: number;
  nRoofHeight: number;
  nDistMin: number;
  nDistMax: number;
  nDistDefault: number;
  bSuccess: boolean = false;

  purlinMinMax = {
    nDistMin: 115,
    nDistMax: 145,
    nDistDefault: 115
  }

  rafterMinMax = {
    nDistMin: 20,
    nDistMax: 100,
    nDistDefault: 80
  }

  trapexCrissCrossDistMax = 200;

  constructor(private routerPath: RouterPathService, private route: ActivatedRoute, private router: Router, public globalF: GlobalFunctionService, public imagePath: ImagePathService, public translate: TranslateService) {
    this.prevPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPShapeString}`;
    this.nextPath = `..${this.routerPath.pathSeperator}${this.routerPath.RPPanelString}`;
  }

  ngOnInit(): void {
    this.fetchInput();
    if (this.globalF.checkTrapezDirect()) {
      this.trapezDirect = true;
    } else {
      this.drawRoof();
    }
  }

  drawRoof() {
    new DrawRoof().initRoof("canvas_stage_for_roof");
  }

  private fetchInput(): void {
    if (SC_Input.iRoofType == RoofType.PANTILED) {
      this.rbPurlin = false;
      this.rbRafter = true;
      SC_Input.iBeamType = SC_Beam.RAFTER;
      this.switchAnchor(AnchorType.ROOF_HOOK);
    } else if (SC_Input.iRoofType == RoofType.TRAPEZOIDAL) {
      this.rbPurlin = true;
      this.rbRafter = false;
      SC_Input.iBeamType = SC_Beam.PURLIN;
      if (SC_Input.iMountingType == MountingType.CRISS_CROSS) {
        this.switchAnchor(AnchorType.HANGER_BOLT);
        this.trapezCrisCross = true;
      }
    } else if (SC_Input.iRoofType == RoofType.CORRUGATED) {
      this.rbPurlin = true;
      this.rbRafter = false;
      SC_Input.iBeamType = SC_Beam.PURLIN;
      this.switchAnchor(AnchorType.HANGER_BOLT);
    } else if (SC_Input.iRoofType == RoofType.SLATED) {
      this.rbPurlin = false;
      this.rbRafter = true;
      SC_Input.iBeamType = SC_Beam.RAFTER;
      this.switchAnchor(AnchorType.NONE);
    } else if (SC_Input.iRoofType == RoofType.PLAIN_TILED) {
      this.rbPurlin = false;
      this.rbRafter = true;
      SC_Input.iBeamType = SC_Beam.RAFTER;
      this.switchAnchor(AnchorType.ROOF_HOOK);
    }
    if (this.rbPurlin) {
      SC_Input.beamMinMax = this.purlinMinMax;
    } else {
      SC_Input.beamMinMax = this.rafterMinMax;
    }
    if (this.trapezCrisCross) {
      SC_Input.beamMinMax.nDistMax = this.trapexCrissCrossDistMax;
    }
    if (!SC_Input.updatedBeamInput) {
      SC_Input.nBeamDist = SC_Input.beamMinMax.nDistDefault;
    }
  }

  private switchAnchor(iAnchor: number): void {
    if (iAnchor == AnchorType.ROOF_HOOK) {
      this.vbPurlinAdditional = false;
      this.hbRoofHook = true;
    } else if (iAnchor == AnchorType.HANGER_BOLT) {
      this.vbPurlinAdditional = true;
      this.hbRoofHook = false;
    } else {
      this.vbPurlinAdditional = false;
      this.hbRoofHook = false;
    }
  }

  goToNext() {
    if (this.bSuccess) {
      return;
    }
    this.router.navigate([this.nextPath], { relativeTo: this.route });
  }

}